import AccountSettingsPageShell from './AccountSettingsPageShell';
import { ConnectedAssistantsManagement } from './ConnectedAssistantsManagement';

/** Safety fallback remains available without a selected brand or an included plan. */
export default function AccountAssistantsPage() {
  return (
    <AccountSettingsPageShell titleKey="mcp.settings.title">
      <ConnectedAssistantsManagement />
    </AccountSettingsPageShell>
  );
}
